import { useMediaQuery, useTheme } from '@mui/material';
import { SearchMembers, SearchTasks } from 'packages/search-and-show';
import globalSearchContext from './use-global-search';

const GlobalSearchSelector: React.VFC = () => {
  const { searchType, currentMemberId, currentTaskId, handleMemberSelect, handleTaskSelect } = globalSearchContext.useController();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (searchType === 'member') {
    return (
      <SearchMembers
        key={currentMemberId}
        memberId={currentMemberId}
        id="searchMember"
        placeholder="Search by Athena Id, Name, Phone or DOB..."
        visiblePlaceholder={isMobile ? 'Search' : undefined}
        onSelect={handleMemberSelect}
      />
    );
  }

  return (
    <SearchTasks
      key={currentTaskId}
      taskId={currentTaskId}
      id="searchTask"
      placeholder="Search by Task ID..."
      visiblePlaceholder={isMobile ? 'Search' : undefined}
      onSelect={handleTaskSelect}
    />
  );
};

export default GlobalSearchSelector;
